import { HeaderTableColumnInterface } from './table.interface';

export interface SelectOptionsInterface {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  id: any;
  name: string;
  disabled?: boolean;
}

export interface PaginationInterface {
  limit: number;
  page: number;
}

export interface TranslocoFunction {
  (key: string): string;
}

export interface TabsInterface {
  link: string;
  label: string;
  tooltip?: string;
  count?: number;
  visible?: boolean;
  routerLinkActiveOptions?: { exact: boolean };
}

export interface UploadMultipleFilesInterface {
  file?: File;
  url?: string;
  order: number;
  id?: string;
}

export enum MultiUploadOrientation {
  horizontal = 'horizontal',
  vertical = 'vertical',
}

export interface RangeDatepickerMInterface {
  dateStart: string | Date | null;
  dateEnd: string | Date | null;
}

export interface TabContentInterface {
  id: string;
  title: string;
}

export interface ResizeStartTableInterface {
  columnIndex: number;
  startX: number;
}

export interface ResizeMoveTableInterface {
  columnIndex: number;
  deltaX: number;
}

export interface FallbackColumnInterface {
  index: number;
  column: HeaderTableColumnInterface;
}

export interface AutocompleteItemInterface {
  id: string;
  name: string;
  subtitle?: string;
  disabled?: boolean;
  statusLabel?: string;
  statusClass?: string;
  statusBadgeClass?: string;
  statusDescription?: string;
}

export interface RemoteSelectOptionInterface extends SelectOptionsInterface {
  imageUrl?: string | null;
}
